import React from 'react';
import PropTypes from 'prop-types';
import './PopConfirm.scss';

class PopConfirm extends React.PureComponent {
  render() {
    const { title, text } = this.props;
    return (
      <span className="admin popover-body">
        <strong>{title}</strong>
        <p>{text}</p>
      </span>
    );
  }
}

PopConfirm.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
};

PopConfirm.defaultProps = {
  title: '',
};

export default PopConfirm;



// WEBPACK FOOTER //
// ./src/components/grids/ViewUsersGrid/subComponents/PopConfirm/PopConfirm.jsx